<template>
  <div>
    <button
      @click="handleReviewClick()"
    >
      <icon
        name="refresh-arrow-circle"
        class="small-icon"
      ></icon>
      Review All
    </button>
    <button
      @click="handleReviewClick('incomplete')"
    >
      <icon
        name="cross-rotated-circle"
        class="small-icon"
      ></icon>
      Review Incomplete
    </button>
    <button
      @click="handleReviewClick('flagged')"
    >
      <icon
        name="flag-filled-white"
        class="small-icon"
      ></icon>
      Review Flagged
    </button>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  methods: {
    handleReviewClick(param) {
      this.$emit('review', param);
    },
  },
};

</script>

<style lang="scss" scoped>
button {
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  font-weight: 600;
}
.small-icon {
  height: 17px;
  margin-right: 0.25rem;
}
</style>
